/**
 * Хранилище тикета эмуляции пользователя ("Войти как").
 *
 * Намеренно sessionStorage, а не localStorage: эмуляция живёт в одной вкладке,
 * новая вкладка = обычный админ, reload переживает, и тикет не смешивается
 * с MSAL-кэшем (тот в localStorage).
 *
 * Чистая функция без React — используется и в api.ts/WebSocketService (не
 * React-контекст), и внутри UI-компонентов.
 */

const STORAGE_KEY = 'impersonation-ticket';

export interface StoredImpersonation {
  ticket: string;
  sessionId: string;
  targetId: string;
  targetName: string;
  targetEmail: string;
  expiresAt: string;
}

export function getStoredImpersonation(): StoredImpersonation | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const data = JSON.parse(raw) as StoredImpersonation;
    if (new Date(data.expiresAt).getTime() <= Date.now()) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function getImpersonationTicket(): string | null {
  return getStoredImpersonation()?.ticket ?? null;
}

export function setStoredImpersonation(data: StoredImpersonation): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function clearStoredImpersonation(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
